import {
    type LessonProgress,
    type ProjectProgress,
    type ProgressStatus,
    type StreamProgress,
} from '../ContentProgress.types';

export const getStreamProgressStatus = (streamProgress?: StreamProgress): ProgressStatus => {
    if (!streamProgress?.startedAt) return 'notStarted';

    if (streamProgress.completedAt) return 'completed';

    return 'inProgress';
};

export const getLessonProgressStatus = (lessonProgress?: LessonProgress): ProgressStatus => {
    if (!lessonProgress?.startedAt) return 'notStarted';

    if (lessonProgress.completedAt) return 'completed';

    return 'inProgress';
};

export const getProjectProgressStatus = (projectProgress?: ProjectProgress): ProgressStatus => {
    if (!projectProgress) return 'notStarted';

    if (projectProgress.markedAsPassed) return 'completed';
    if (projectProgress.waived) return 'completed';
    if (typeof projectProgress.score === 'number') return 'completed';

    return 'inProgress';
};
